module.exports = __webpack_public_path__ + "static/media/sort-asc.ac14fe96.svg";